












































import { MotivosCancelamentoFiscal, Page, Pageable } from '@/models';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { FindMotivoDeCancelamentoFiscalUseCase } from '@/usecases';
import axios, { CancelTokenSource } from 'axios';
import {PropSync, Ref, Vue, Component } from 'vue-property-decorator'

@Component
export default class SeletorDeMotivosDeCancelamentoFiscal extends Vue {
	@Ref() campo!: HTMLInputElement
	@PropSync('value') selecionado?: MotivosCancelamentoFiscal | MotivosCancelamentoFiscal[] | string | string[]

	busca: string | null = null
	motivos: MotivosCancelamentoFiscal[] = []
	carregando = true

	pageable: Pageable = {
		page: 0,
		size: 3,
	}
	pagina: Page<MotivosCancelamentoFiscal> | null = null
	cancelToken: CancelTokenSource | null = null
	FindMotivoDeCancelamentoFiscalUseCase = new FindMotivoDeCancelamentoFiscalUseCase

	created() {
		this.carregarSelecao()
	}
	
	get carregouTodosOsMotivos() {
		return this.pagina?.last || false
	}

	get noDataMessage() {
		if (this.carregando) {
			return 'Carregando...'
		}
		if (!this.busca) {
			return 'Digite para consultar...'
		}
		return '$vuetify.noDataText'
	}

	get motivosFiltrados() {
		return this.motivos
	}

	async pageNext() {
		this.pageable.page = !this.pageable.page
			? 1
			: this.pageable.page += 1

		await this.find()
	}

	extrairId(objeto: MotivosCancelamentoFiscal | string | null): string {
		if (objeto === null) {
			throw new Error("Motivo não encontrado");
		}
		if (typeof objeto === 'object') {
			return objeto.id as string;
		}
		return objeto.toString();
	}

	async carregarSelecao() {
		if (!this.selecionado) {
			return this.find()
		}
		const ids: string[] = Array.isArray(this.selecionado)
			? (this.selecionado as (string | MotivosCancelamentoFiscal)[]).map(this.extrairId)
			: [this.extrairId(this.selecionado)]
		try {
			this.carregando = true

			this.cancelToken = axios.CancelToken.source()
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			this.pagina = await this.FindMotivoDeCancelamentoFiscalUseCase.findAll({
				ids,
			}, axiosConfig)
			this.pagina.content.forEach(loja => {
				this.motivos.push(loja)
			})
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	async find() {
		if (this.cancelToken) this.cancelToken.cancel()
		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()
			this.pagina = await this.FindMotivoDeCancelamentoFiscalUseCase.findAll({
				page: this.pageable.page || 0,
				size: this.pageable.size,
				busca: this.busca || undefined,
			},
			{
				cancelToken: this.cancelToken.token,
			})
			this.pagina.content.forEach(motivo => {
				if (this.motivos.some(({ id }) => motivo.id === id)) return
				this.motivos.push(motivo)
			})
			this.carregando = false
		} catch (error: any) {
			if (axios.isCancel(error)) return
			this.pagina = null
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	focus() {
		this.campo.focus()
	}
}
